import React from 'react';
import CheckBox from '@common/Forms/CheckBox';
import CmsRenderer from '@core_modules/cms/components/cms-renderer';
import Typography from '@common/Typography';
import cx from 'classnames';
import { getCmsBlocks } from '@core_modules/cms/services/graphql';
import Skeleton from '@common/Skeleton';

const PersonalDataConsent = (props) => {
    const {
        storeConfig, handlePersonalDataConsent,
        formik,
    } = props;

    // get personal data consent
    const identifierConsent = 'personal_data_consent';
    const {
        data: dataConsent,
        loading: loadingConsent,
        error: errorConsent,
    } = getCmsBlocks({ identifiers: [identifierConsent] });

    return (
        <div className={cx('mt-5', 'data-consent-section')}>
            <CheckBox
                variant="single"
                classNames={{
                    // checkboxClasses: 'w-[15px] h-[15px] mt-[2px] mr-[15px] tablet:mt-0',
                    checkboxContainerClasses: 'flex data-consennt',
                }}
                checked={!!(formik.values.personalDataConsent !== '0')}
                onChange={handlePersonalDataConsent}
                name="personalDataConsent"
                id="personal-data-consent-cb"
                disabled={!!(formik.initialValues.personalDataConsent === '1')}
            >
                <label className="label-data-consent flex w-[100%] flex-col">
                    {dataConsent && !loadingConsent && !errorConsent ? (
                        <>
                            <CmsRenderer content={dataConsent?.cmsBlocks?.items[0]?.content} storeConfig={storeConfig} />
                        </>
                    ) : null}
                    {loadingConsent ? (
                        <div className="flex flex-col gap-2">
                            <Skeleton className="block !w-full" width={280} height={24} />
                            <Skeleton className="block !w-full" width={280} height={24} />
                        </div>
                    ) : null}

                </label>
            </CheckBox>
            {!!(formik.touched.personalDataConsent && formik.errors.personalDataConsent) && (
                <div>
                    <Typography className={cx('text-red text-sm')}>
                        {(formik.touched.personalDataConsent && formik.errors.personalDataConsent) || null}
                    </Typography>
                </div>
            )}
        </div>
    );
};

export default PersonalDataConsent;
